import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import {
    EventCodeType,
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { FIXED_KEYS_DOUBLE } from '../schema/constant';

export const DOUBLE_TAB_CLICK_MAP = {
    [FIXED_KEYS_DOUBLE.TOOLBAR_START]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.START_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_START_TAB_CLK,
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_INSERT]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_CLK,
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_EFFICIENCY]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_EFFICIENT_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_EFFICIENT_TAB_CLK,
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_PLAY]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_PLAY_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_PLAY_TAB_CLK,
    },
};

export const TOOLBAR_REPORT_MAP = {
    [FIXED_KEYS_DOUBLE.TOOLBAR_START]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.START_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_START_TAB_CLK,
    }),
    [FIXED_KEYS_DOUBLE.TOOLBAR_INSERT]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_CLK,
    }),
    [FIXED_KEYS_DOUBLE.TOOLBAR_EFFICIENCY]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_EFFICIENT_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_EFFICIENT_TAB_CLK,
    }),
    [FIXED_KEYS_DOUBLE.TOOLBAR_PLAY]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_PLAY_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_PLAY_TAB_CLK,
    }),
    [FIXED_KEYS_DOUBLE.TOOLBAR_ANIM]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.ANIMATION_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_ANIMATION_TAB_CLK,
    }),
    [FIXED_KEYS_DOUBLE.TOOLBAR_BEAUTIFY]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.BEAUTIFY_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_BEAUTIFY_TAB_CLK,
    }),
    [FIXED_KEYS_DOUBLE.TOOLBAR_TABLE]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TABLE_STYLE_TAB,
        action: TDWActionType.CLK,
    }),
    [FIXED_KEYS_DOUBLE.TOOLBAR_TABLE_POSITION]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TABLE_LAYOUT_TAB,
        action: TDWActionType.CLK,
    }),
    [FIXED_KEYS_DOUBLE.TOOLBAR_VIEW]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_VIEW_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_VIEW_TAB_CLK,
    }),
    [FIXED_KEYS_DOUBLE.TOOLBAR_COMMENT]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_REVIEW_TAB,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_REVIEW_TAB_CLK,
    }),
    [ActionType.SINGLE_TOOLBAR_MENU]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.S_MENU,
        action: TDWActionType.CLK,
        eventcode: EventCodeType.DOC_PPT_S_MENU_CLK,
    }),
    [ActionType.EDIT_VIEW]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_VIEW_TAB,
        action: TDWActionType.NORMAL,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_VIEW_TAB_NORMAL,
    }),
    [ActionType.MASTER_VIEW]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_VIEW_TAB,
        action: TDWActionType.MASTER,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_VIEW_TAB_MASTER,
    }),
    [ActionType.DISPLAY_TEXT_RULER]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_VIEW_TAB,
        action: TDWActionType.RULER,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_VIEW_TAB_RULER,
    }),
    [ActionType.DISPLAY_GUIDES]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_VIEW_TAB,
        action: TDWActionType.GUIDES,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_VIEW_TAB_GUIDES,
    }),
    [ActionType.DISPLAY_GRID_LINE]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_VIEW_TAB,
        action: TDWActionType.GRIDLINE,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_VIEW_TAB_GRIDLINE,
    }),
    [ActionType.TOGGLE_SNAP_LINE]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_VIEW_TAB,
        action: TDWActionType.SNAP_LINE,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_VIEW_TAB_SNAP_LINE,
    }),
    [ActionType.NOTE_SWITCH]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_VIEW_TAB,
        action: TDWActionType.NOTE,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_VIEW_TAB_NOTE,
    }),
    [ActionType.ADJUST_SLIDE]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_VIEW_TAB,
        action: TDWActionType.ZOOM,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_VIEW_TAB_ZOOM,
    }),
    [ActionType.AUTO_ADJUST_SLIDE]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_VIEW_TAB,
        action: TDWActionType.AUTO_ZOOM,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_VIEW_TAB_AUTO_ZOOM,
    }),
    [ActionType.ANIM_CORNER_MARK]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_VIEW_TAB,
        action: TDWActionType.CORNER_MARK_HIDDON,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_VIEW_TAB_CORNER_MARK,
    }),
    [ActionType.INSERT_COMMENT]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_REVIEW_TAB,
        action: TDWActionType.ADD_COMMENTS,
        eventcode: EventCodeType.DOC_PPT_COMMENTS_ADD_COMMENTS,
    }),
    [ActionType.JUMP_TO_PREV_COMMENT]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_REVIEW_TAB,
        action: TDWActionType.LAST_COMMENTS,
        eventcode: EventCodeType.DOC_PPT_REVIEW_TAB_LAST_COMMENTS,
    }),
    [ActionType.JUMP_TO_NEXT_COMMENT]: () => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_REVIEW_TAB,
        action: TDWActionType.NEXT_COMMENTS,
        eventcode: EventCodeType.DOC_PPT_REVIEW_TAB_NEXT_COMMENTS,
    }),
};

// 工具栏双栏新增TAB和单栏菜单menu相同功能上报
export const TOOLBAR_AND_MENU_REPORT_INFO = {
    [ActionType.INSERT_BLANK_SLIDE]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.PAGE,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_PAGE,
    },
    [ActionType.INSERT_TEMPLATE_SLIDE]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.TEMPLATE,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_TEMPLATE,
    },
    [ActionType.INSERT_TEXT]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.TEXT_BOX,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_TEXT_BOX,
    },
    [ActionType.INSERT_PICTURE]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.PICTURES,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_PICTURES,
    },
    [ActionType.INSERT_WITH_LINK]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.LINK,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_LINK,
    },
    [ActionType.INSERT_WITH_LATEX]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.LATEX,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_LATEX,
    },
    [ActionType.INSERT_SLIDE_FOOTER]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.FOOTER,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_FOOTER,
    },
    [ActionType.INSERT_TENCENT_DOC_ID]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.TDOCS,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_TDOCS,
    },
    [ActionType.UPLOAD_LOCAL_FILE]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.FILES,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_FILES,
    },
    [ActionType.INSERT_IFRAME]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_INSERT_TAB,
        action: TDWActionType.ADDON,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_ADDON,
    },
    [ActionType.MUTI_PICTURE_EXPORT]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_EFFICIENT_TAB,
        action: TDWActionType.DOWNLOAD_PIC,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_EFFICIENT_TAB_DOWNLOAD_PIC,
    },
    [ActionType.PDF_TRANSFORM]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_EFFICIENT_TAB,
        action: TDWActionType.CONVERT_PDF,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_EFFICIENT_TAB_CONVERT_PDF,
    },
    [ActionType.EXPORT_IMAGE]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_EFFICIENT_TAB,
        action: TDWActionType.CREATE_PIC,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_EFFICIENT_TAB_CREATE_PIC,
    },
    [ActionType.INTELLIGENT_TOOL]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_EFFICIENT_TAB,
        action: TDWActionType.ADDON,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_EFFICIENT_TAB_ADDON,
    },
    [ActionType.LOCAL_PLAY_FROM_BEGIN]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_PLAY_TAB,
        action: TDWActionType.BEGIN,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_PLAY_TAB_BEGIN,
    },
    [ActionType.LOCAL_PLAY_FROM_CURRENT]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_PLAY_TAB,
        action: TDWActionType.CURRENT,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_PLAY_TAB_CURRENT,
    },
    [ActionType.LOCAL_WITH_PRESENTER_VIEW]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_PLAY_TAB,
        action: TDWActionType.NOTE_VIEW,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_PLAY_TAB_NOTE_VIEW,
    },
    [ActionType.REMOTE_PLAY]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_PLAY_TAB,
        action: TDWActionType.REMOTE,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_PLAY_TAB_REMOTE,
    },
    [ActionType.TENCENT_MEETING_PLAY]: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.TOOLBAR_PLAY_TAB,
        action: TDWActionType.TMEETING,
        eventcode: EventCodeType.DOC_PPT_TOOLBAR_PLAY_TAB_TMEETING,
    },
};
